import { LocaleMessages } from 'shared-types';

const getCustomizedError = (messages: LocaleMessages, error: string) => {
  if (error === 'rate_limit_exceeded') {
    return messages.aiToolsErrorRateLimitExceeded;
  } else if (error === 'notify_vuolearning') {
    return messages.aiToolsErrorNotifyVuolearning;
  } else if (error === 'service_unavailable') {
    return messages.aiToolsErrorServiceUnavailable;
  } else if (error === 'invalid_response_format') {
    return messages.aiToolsErrorInvalidResponseFormat;
  } else {
    return error;
  }
};

export default getCustomizedError;
